export const IMAGES = {
  heroWarehouse: {
    src: "https://images.unsplash.com/photo-1642055514517-7b52288890ec?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    alt: "Organised pharmaceutical distribution shelves stocked with medicine cartons",
  },
  logistics: {
    src: "https://images.unsplash.com/photo-1576669801820-a9ab287ac2d1?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
    alt: "Forklift moving palletised cartons inside a distribution warehouse",
  },
  compliance: {
    src: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    alt: "Sealed medicine blister packs representing genuine pharmaceutical supply",
  },
  meeting: {
    src: "https://images.unsplash.com/photo-1739298061707-cefee19941b7?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
    alt: "Trade representatives seated around a table during an association meeting",
  },
  meetingWide: {
    src: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
    alt: "Members of a trade body in discussion during a working session",
  },
};
